import countries from 'i18n-iso-countries'
import enCountries from 'i18n-iso-countries/langs/en.json'
import fiCountries from 'i18n-iso-countries/langs/fi.json'
import svCountries from 'i18n-iso-countries/langs/sv.json'
import deCountries from 'i18n-iso-countries/langs/de.json'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getCurrentLocale, ValidLocale } from '@localisation/utils.ts'
import resourcesToBackend from 'i18next-resources-to-backend'
import locales from './locales/_locale.json'

countries.registerLocale(fiCountries)
countries.registerLocale(svCountries)
countries.registerLocale(enCountries)
countries.registerLocale(deCountries)

enum Format {
  CURRENCY = 'currency',
  PERCENTAGE = 'percentage'
}

const NAMESPACE = 'common_localisation'

export const i18nInstance = i18next.createInstance()

// Initialize i18next with a default configuration
i18nInstance
  .use(
    resourcesToBackend(language => {
      if (language === 'locale') {
        return Promise.resolve(locales)
      }
      switch (language) {
        case 'fi':
          return import('./locales/fi.json')
        case 'sv':
          return import('./locales/sv.json')
        case 'de':
          return import('./locales/de.json')
        case 'en':
        default:
          return import('./locales/en.json')
      }
    })
  )
  .use(initReactI18next)
  .init(
    {
      lng: getCurrentLocale(),
      supportedLngs: [...Object.values(ValidLocale), 'locale'],
      fallbackLng: ValidLocale.EN,
      ns: [NAMESPACE],
      defaultNS: NAMESPACE,
      interpolation: {
        escapeValue: false,
        format: (value, format: Format) => {
          if (format === Format.CURRENCY) {
            return new Intl.NumberFormat('fi-FI', { style: 'currency', currency: 'EUR' }).format(
              value
            )
          }
          if (format === Format.PERCENTAGE) {
            return Intl.NumberFormat('fi-FI', {
              style: 'percent',
              maximumFractionDigits: 2
            }).format(value / 100)
          }
          return value
        }
      },
      debug: false,
      react: {
        useSuspense: true
      }
    },
    () => {
      Object.keys(locales).forEach(lang => {
        i18nInstance.addResourceBundle(
          lang,
          NAMESPACE,
          { ...locales[lang], ...locales.__common__ },
          true,
          true
        )
      })
    }
  )
